import { memo } from 'react';

import { Button, ButtonProps } from '@/components/core';
import { CloseIcon } from '@/components/icons';
import { SVGProps } from '@/utils';

export type CloseButtonProps = ButtonProps & {
  props?: {
    icon?: SVGProps;
  };
};

const ICloseButton = ({ className, props, ...rest }: CloseButtonProps) => {
  const { className: iconClassName, ...iconProps } = props?.icon ?? {};

  return (
    <Button className={className} variant="plain" {...rest}>
      <CloseIcon className={iconClassName} {...iconProps} />
    </Button>
  );
};

export const CloseButton = memo(ICloseButton) as typeof ICloseButton;
